import { watch } from 'vue'
import { useCartStore } from '@/stores'
import { swalError } from '@/utils'

const CART_MAX = 15

export function useCart() {
  /** カートのストア */
  const cart = useCartStore()

  // カートを監視
  watch(
    () => cart.list,
    (val, oldVal) => {
      if (val.length > CART_MAX) {
        // 最大数を超えた場合
        // カートを元に戻す
        cart.list = oldVal
        // エラーダイアログを出す
        swalError({ text: `資料請求できるのは${CART_MAX}校までです。` })
      } else {
        // LocalStorageと同期する
        cart.store()
      }
    },
  )

  return { cart, CART_MAX }
}
